import React from "react";
import { PORT_COLOR_MAP, PortColor } from "../../utils/appConstants";

interface PortImageInterface {
  color: PortColor;
  plugColor: PortColor;
  size?: number;
}

const PortImage: React.FC<PortImageInterface> = (props) => {
  const color = PORT_COLOR_MAP[props.color];
  const plug = PORT_COLOR_MAP[props.plugColor];
  const size = props.size || 32;

  return (
    <div style={{ width: size, height: size }}>
      <svg width="100%" viewBox="0 0 32 32">
        <rect fill={color} height="32" stroke={color} width="32" x="0" y="0" />
        <rect fill="#ffffff" height="16" stroke={color} strokeWidth="0" width="24" x="4" y="4.91" />
        <rect fill="#ffffff" height="11" stroke={color} strokeWidth="0" transform="matrix(1 0 0 1 0 0)" width="18" x="7" y="13" />
        <rect fill="#ffffff" height="22" stroke={color} strokeWidth="0" transform="matrix(1 0 0 1 0 0)" width="12" x="10" y="5" />
        <rect fill={plug} height="12" stroke={color} strokeWidth="0" width="20" x="6" y="7" />
        <rect fill={plug} height="12" stroke={color} strokeWidth="0" transform="matrix(1 0 0 1 0 0)" width="14" x="9" y="9.98" />
        <rect fill={plug} height="11" stroke={color} strokeWidth="0" width="8" x="12" y="14" />
      </svg>
    </div>
  );
};

export default PortImage;
